import { createSelector } from "reselect";
import { getAppConfig, getSelectedArea, getSelectedCinema, getUserInfo } from ".";
import { filterMenuItemsByVisibility } from "../utils/menuFilters";
import { MenuItem } from "../types/menu-item";
import { replaceDynamicUrlParams } from "../utils/urls";

interface Menus {
    header: MenuItem[];
    secondary: MenuItem[];
    navBar: MenuItem[];
    hamburger: MenuItem[];
}

export const getMenus = createSelector(
    [getAppConfig],
    (config) => (config && config.menus) ? config.menus : {}
);

const getHeaderMenuItems = createSelector(
    [getMenus, getUserInfo, getSelectedArea, getSelectedCinema],
    (menus: Menus, user, area, cinema) => filterAndParseMenuItems((menus.header || []), user, area, cinema)
);

export const getDesktopHeaderMenu = createSelector(
    [getHeaderMenuItems],
    (items) => items.filter(item => item.position < 100)
);

export const getDesktopHeaderSubMenu = createSelector(
    [getHeaderMenuItems],
    (items) => items.filter(item => item.position >= 100 && item.position < 200)
);

export const getDesktopHeaderRightMenu = createSelector(
    [getHeaderMenuItems],
    (items) => items.filter(item => item.position >= 200)
);

export const getSecondaryMenu = createSelector(
    [getMenus, getUserInfo, getSelectedArea, getSelectedCinema],
    (menus: Menus, user, area, cinema) => filterAndParseMenuItems((menus.secondary || []), user, area, cinema)
);

export const getMobileFooterMenu = createSelector(
    [getMenus, getUserInfo, getSelectedArea, getSelectedCinema],
    (menus: Menus, user, area, cinema) => filterAndParseMenuItems((menus.navBar || []), user, area, cinema)
);

export const getMobileMenu = createSelector(
    [getMenus, getUserInfo, getSelectedArea, getSelectedCinema],
    (menus: Menus, user, area, cinema) => filterAndParseMenuItems((menus.hamburger || []), user, area, cinema)
);

function filterAndParseMenuItems(items: MenuItem[], user: any, area, cinema): MenuItem[] {
    return filterMenuItemsByVisibility(items, user).map(item => {
        const newItem = { ...item };
        newItem.url = replaceDynamicUrlParams(newItem.url || '', { area, cinema });
        return newItem;
    }).filter(item => !!item.url);
}